import axios from 'axios'
import global from '@/global/variable.js'

// 获取物料列表
export function getList(data) {
  const url = global.requestUrl + '/material/list?limit=' + data.limit + '&page=' + data.page
  return axios.get(url)
}

// 创建物料信息
export function createOne(data) {
  const url = global.requestUrl + '/material/create'
  return axios.post(url, data)
}

// 更新物料信息
export function updateOne(data) {
  const url = global.requestUrl + '/material/update'
  return axios.post(url, data)
}

// 删除物料信息
export function deleteOne(data) {
  const url = global.requestUrl + '/material/delete/' + data.id
  return axios.get(url)
}

// 获取待检测列表
export function getMaterialCheckList(data) {
  const url = global.requestUrl + '/dualCheck/list?limit=' + data.limit + '&page=' + data.page 
              + '&startDate=' + data.startDate + '&endDate=' + data.endDate 
              + '&status=' + data.status + '&plateNumber=' + data.plateNumber
  return axios.get(url)
}

// 粉料检测申请
export function createMaterialCheckOne(data) {
  const url = global.requestUrl + '/dualCheck/create'
  return axios.post(url, data, {headers: {
    'Content-Type':'multipart/form-data'
  }})
}

// 粉料检测审核
export function updateMaterialCheckOne(data) {
  const url = global.requestUrl + '/dualCheck/check'
  return axios.post(url, data, {headers: {
    'Content-Type':'multipart/form-data'
  }})
}